<div class="company-container mt-2">
  <div class="top-part pt">
    <div class="top-part-wrap">
      <div class="table-main-header">Carrier Marketplace Mappings</div>
      <div class="d-flex">
        <div class="searchbox d-flex me-2" id="searchbox">
          <img src="assets/images/products-listing/searchbar.png" />
          <input
            type="text"
            class="ms-2"
            placeholder="Search..."
            id="search-input"
            [ngModel]="search"
            (ngModelChange)="handleSearch($event)"
          />
        </div>
        <button
          class="btn primary-btn ms-2"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasAddCarrierMarketplaceMapping"
          (click)="openAddEditForm(0)"
          aria-controls="offcanvasRight"
          style="height: 43px;"
        >
          <img src="assets/images/icons/Plus_Icon.svg" class="me-1" />Add Mapping
        </button>
      </div>
    </div>
  </div>

  <div class="table-container user-table">
    <div *ngIf="loading" class="loading-overlay">
      <div class="spinner-border text-primary custom-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <table class="table locationtype-table align-middle">
      <thead class="br-10">
        <tr>
          <th class="col ps-3" style="width: 25%">Carrier</th>
          <th class="col" style="width: 20%">Marketplace</th>
          <th class="col" style="width: 25%">Shipping Name</th>
          <th class="col" style="width: 20%">Shipping Code</th>
          <th class="col text-center" style="width: 10%">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let mapping of filteredMappings">
          <td class="ps-3">{{ mapping.carrierName }}</td>
          <td>{{ getMarketplaceLabel(mapping.marketplace) }}</td>
          <td>{{ mapping.shippingName }}</td>
          <td>{{ mapping.shippingCode }}</td>
          <td>
            <div class="d-flex justify-content-center">
              <button
                class="btn p-0 c-pt me-3"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasAddCarrierMarketplaceMapping"
                aria-controls="offcanvasRight"
                (click)="openAddEditForm(mapping.id)"
                style="border: none"
                matTooltipPosition="above"
                matTooltip="Edit Record"
              >
                <img src="assets/images/icons/edit_ic.svg" />
              </button>
              <button
                class="btn border-0 p-0 c-pt"
                data-bs-toggle="modal"
                data-bs-target="#deleteCarrierMarketplaceMappingModal"
                style="border: none"
                matTooltipPosition="above"
                matTooltip="Delete Record"
                (click)="selectRecordToDelete(mapping)"
              >
                <img src="assets/images/icons/Delete_icon.svg" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      *ngIf="filteredMappings.length === 0"
      class="nodata"
      style="height: 56vh; display: flex; align-items: center"
    >
      <p style="margin: auto; font-size: 2rem; color: #a4a4a4">No Data Available</p>
    </div>
  </div>
</div>

<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasAddCarrierMarketplaceMapping"
  aria-labelledby="offcanvasRightLabel"
  data-bs-backdrop="static"
>
  <ng-container>
    <app-add-edit-carrier-marketplace-mapping
      #addEditComponent
      (triggerParentMethod)="handleTriggerFromChild()"
    ></app-add-edit-carrier-marketplace-mapping>
  </ng-container>
</div>

<div
  class="modal fade"
  id="deleteCarrierMarketplaceMappingModal"
  aria-hidden="true"
  tabindex="-1"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Confirm Deletion</h5>
      </div>
      <div class="modal-body">
        <p>
          Are you sure you want to delete this mapping for "<b>{{ selectedMapping.carrierName }}</b>"?
        </p>
        <p class="mt-3" style="font-weight: 600">
          This action will permanently remove the carrier marketplace mapping from the records.
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn pri-btn me-2" data-bs-dismiss="modal">Cancel</button>
        <button
          class="btn cancel-btn ms-2 w-auto"
          data-bs-dismiss="modal"
          (click)="deleteRecord()"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>
